import { Component, OnInit } from '@angular/core';
import { BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-text-editor',
    templateUrl: './block-text-editor.component.html',
})

export class BlockTextEditorComponent extends BlockAbstractComponent implements OnInit {

}
